import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LIVE_URL = "https://afromagicbraiding.shop";

const WindowStickerPage = () => {
  const [qrUrl, setQrUrl] = useState("");

  useEffect(() => {
    setQrUrl(`${API}/qrcode?url=${encodeURIComponent(LIVE_URL)}`);
  }, []);

  const handlePrint = () => window.print();

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="window-sticker-page">
      {/* Header - hidden on print */}
      <header className="border-b border-brand-border bg-brand-surface px-6 py-4 flex items-center justify-between print:hidden">
        <Link to="/" className="font-serif text-xl text-brand-text">Afro <span className="text-brand-gold">Magic</span></Link>
        <div className="flex items-center gap-4">
          <button onClick={handlePrint} className="flex items-center gap-2 px-4 py-2 bg-brand-gold text-black font-sans text-sm font-semibold hover:bg-brand-gold-light transition-colors" data-testid="sticker-print-btn">
            <Printer size={16} /> Print Sticker
          </button>
          <Link to="/" className="flex items-center gap-1 font-sans text-xs text-brand-text-muted hover:text-brand-gold"><ArrowLeft size={14} /> Back</Link>
        </div>
      </header>

      {/* Sticker */}
      <div className="flex justify-center py-8 print:py-0">
        <div
          className="w-[8.5in] min-h-[11in] bg-black border-[4px] border-[#D4AF37] p-8 print:border-[6px]"
          style={{ fontFamily: "Arial, sans-serif" }}
          data-testid="window-sticker"
        >
          {/* Top accent line */}
          <div className="h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mb-6" />

          {/* Header */}
          <div className="text-center mb-6">
            <h1 style={{ fontFamily: "Georgia, serif", fontSize: "42px", color: "#D4AF37", marginBottom: "8px", letterSpacing: "2px" }}>
              AFRO MAGIC BRAIDING
            </h1>
            <p style={{ fontSize: "14px", color: "#D6CFC4", letterSpacing: "4px", textTransform: "uppercase" }}>Premium African Hair Braiding</p>
          </div>

          {/* Tagline */}
          <div className="text-center mb-6" style={{ background: "rgba(212,175,55,0.1)", border: "1px solid rgba(212,175,55,0.3)", padding: "12px 20px" }}>
            <p style={{ fontSize: "20px", color: "#FDFBF7", fontWeight: "bold" }}>Step In. Glow Up. Walk Out Confident.</p>
            <p style={{ fontSize: "13px", color: "#D6CFC4", marginTop: "4px" }}>Neat, stylish, and long-lasting braids — we've got you covered!</p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-2 gap-x-6 gap-y-2 mb-6 px-4">
            {[
              "Knotless Braids",
              "Box Braids",
              "Cornrows",
              "Boho Braids",
              "Fulani Braids",
              "Crochet Styles",
              "Men's Braids",
              "Twists & More",
              "Faux Locs",
              "Kids & Adults Welcome",
            ].map((service) => (
              <div key={service} className="flex items-center gap-2 py-1">
                <span style={{ color: "#D4AF37", fontSize: "14px" }}>&#10003;</span>
                <span style={{ color: "#FDFBF7", fontSize: "15px" }}>{service}</span>
              </div>
            ))}
          </div>

          {/* Highlights bar */}
          <div className="text-center mb-6" style={{ borderTop: "1px solid rgba(212,175,55,0.3)", borderBottom: "1px solid rgba(212,175,55,0.3)", padding: "10px 0" }}>
            <p style={{ fontSize: "16px", color: "#D4AF37", fontWeight: "bold", letterSpacing: "1px" }}>FAST &bull; AFFORDABLE &bull; PROFESSIONAL QUALITY</p>
          </div>

          {/* QR Code + Booking Info */}
          <div className="flex items-center justify-between gap-6 mb-6 px-2">
            <div className="flex-1">
              <p style={{ fontSize: "16px", color: "#D4AF37", fontWeight: "bold", marginBottom: "8px" }}>WALK-INS WELCOME!</p>
              <p style={{ fontSize: "15px", color: "#FDFBF7", marginBottom: "4px" }}>Book Online in 60 Seconds</p>
              <p style={{ fontSize: "13px", color: "#D6CFC4", marginBottom: "12px" }}>afromagicbraiding.shop</p>
              <p style={{ fontSize: "14px", color: "#FDFBF7", marginBottom: "4px" }}>Call/Text: <span style={{ color: "#D4AF37", fontWeight: "bold" }}>(313) 484-7307</span></p>
              <p style={{ fontSize: "12px", color: "#D6CFC4" }}>afromagicbraidinghair@gmail.com</p>
            </div>
            <div className="text-center flex-shrink-0">
              {qrUrl && <img src={qrUrl} alt="Scan to Book" style={{ width: "200px", height: "200px", border: "4px solid #D4AF37", padding: "10px", background: "#FFFFFF" }} />}
              <p style={{ fontSize: "12px", color: "#D4AF37", marginTop: "8px", fontWeight: "bold" }}>SCAN TO VIEW &amp; BOOK</p>
            </div>
          </div>

          {/* Booking Banner */}
          <div className="text-center mb-6" style={{ background: "#D4AF37", padding: "12px 20px" }}>
            <p style={{ fontSize: "18px", color: "#0F0C09", fontWeight: "bold" }}>BOOK ONLINE — YOUR $25 DEPOSIT COUNTS TOWARD YOUR SERVICE!</p>
          </div>

          {/* Bottom info */}
          <div className="text-center">
            <p style={{ fontSize: "13px", color: "#D6CFC4", marginBottom: "6px" }}>Friendly Service &bull; Clean Environment &bull; Satisfaction Guaranteed</p>
            <p style={{ fontSize: "15px", color: "#FDFBF7", fontWeight: "bold" }}>Come in today and transform your look!</p>
          </div>

          {/* Bottom accent line */}
          <div className="h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mt-6" />

          {/* Address */}
          <p className="text-center mt-4" style={{ fontSize: "12px", color: "#D6CFC4" }}>22560 Telegraph Rd, Southfield, MI 48033</p>
          <p className="text-center mt-1" style={{ fontSize: "10px", color: "rgba(214,207,196,0.5)" }}>Afro Magic Braiding is a trade name of HY SERVICES LLC.</p>
        </div>
      </div>
    </div>
  );
};

export default WindowStickerPage;
